export const environment = {
  production: false,
  firebase: {
    apiKey: "AIzaSyDSigMa68DmUwuBcAZzJVc0Z63ya5x9umk",
    authDomain: "recipes-dev-84098.firebaseapp.com",
    projectId: "recipes-dev-84098",
    storageBucket: "recipes-dev-84098.firebasestorage.app",
    messagingSenderId: "140261675406",
    appId: "1:140261675406:web:fff04d908fae11068c94df"
  },
  wasabi: {
    accessKeyId: 'KPHDC7QFS1RPWP008SHV',
    secretAccessKey: 'DRQ31GpeGXeSfdEeGP0Tqum0eZMCowaJa5NiRm2Y',
    region: 'eu-central-2',
    endpoint: 'https://s3.eu-central-2.wasabisys.com',
    bucket: 'recipes-dev'
  },
  /** Instagram reels: use Firebase Callable (listInstagramReels). Optional apiUrl for custom backend. */
  instagram: {
    useCallable: true,
    apiUrl: undefined as string | undefined,
  },
  /** GA4 Property ID (numeric). Empty string = use mock data. Fill in from GA4 Admin → Property Settings. */
  ga4PropertyId: '530842478',
  /** Algolia: dev uses a dedicated Algolia app (separate from prod) so the two never interact. */
  algolia: {
    appId: 'GIBO4Q9CH4',
    searchApiKey: 'b60b2ba1cc7acbb5b50ce8babd072b95',
    indices: {
      recipes: 'recipes',
      kidsRecipes: 'kidsRecipes',
      videos: 'videos',
      kidsVideos: 'kidsVideos',
      recipeProducts: 'recipeProducts',
      recipeSupplies: 'recipeSupplies',
    },
  },
};